const SpecialAddScenarios = [
  { value: "UCM01", label: "Mousse" },
  { value: "UCL02", label: "Literie" },
  { value: "UCN02", label: "Non tissé" },
];

export default SpecialAddScenarios;
